import "core-js/modules/es.number.constructor.js";
import request, { post, get } from '@/utils/request';

//添加量表类型
export function addScaleType(data) {
  return request({
    url: '/system/business/addScaleType',
    method: 'post',
    data: data
  });
}
//修改量表类型
export function updateScaleType(data) {
  return request({
    url: '/system/business/updateScaleType',
    method: 'post',
    data: data
  });
}
//删除量表类型
export function deleteScaleType(params) {
  return request({
    url: '/system/business/deleteScaleType',
    method: 'post',
    params: params
  });
}
//获取量表类型列表
export function getScaleTypeList(data) {
  return request({
    url: '/system/business/getScaleType',
    method: 'post',
    data: data
  });
}
//获取全部患者
export function getScaleType(data) {
  return request({
    url: '/system/patient/getScaleType',
    method: 'post',
    data: data
  });
}
//添加修改患者
export function addPatient(data) {
  return request({
    url: '/api/patient/addPatient',
    method: 'post',
    data: data
  });
}
//获取患者详情
export function getPatientD(data) {
  return request({
    url: '/api/patient/getPatient',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//获取我的患者
export function getMyPatients(data) {
  return request({
    url: '/api/patient/getPatients',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//获取全部评估列表
export function getAssessAll(data) {
  return request({
    url: '/system/business/getAssessAll',
    method: 'post',
    data: data
  });
}
export var getAssessAllNew = function getAssessAllNew(d) {
  return post("/system/business/getNewAssessAll", d);
};
//获取评估详情
// export function getScaleD (data) {
//   return request({
//     url: '/system/business/getScale',
//     method: 'post',
//     data,
//     headers: {
//       isQs: true
//     }
//   })
// }
//获取评估详情
export function getScaleD(data) {
  return request({
    url: '/api/scale/getScaleDetails',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//获取评估详情跟pad同步版
export function getScaleD2(data) {
  return request({
    url: 'api/scale/scale',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}

//获取量表列表
export function getScales(params) {
  return request({
    url: '/system/business/getScales',
    method: 'post',
    params: params
  });
}
//添加量表
export function addScale(data) {
  return request({
    url: '/system/business/addScale',
    method: 'post',
    data: data
  });
}
//修改量表
export function updateScale(data) {
  return request({
    url: '/system/business/updateScale',
    method: 'post',
    data: data
  });
}
//删除量表
export function deleteScale(params) {
  return request({
    url: '/system/business/deleteScale',
    method: 'post',
    params: params
  });
}
//查看量表
export function lookScale(params) {
  return request({
    url: '/system/business/lookScale',
    method: 'post',
    params: params
  });
}
//预览量表
export function preScale(params) {
  return request({
    url: '/system/business/preScale',
    method: 'post',
    params: params
  });
}
//获取指标项列表
export function getIItemList(params) {
  return request({
    url: '/system/business/getIItemList',
    method: 'post',
    params: params
  });
}
//批量添加添加指标项
export function addIndicatorItem(data) {
  return request({
    url: '/system/business/addIndicatorItem',
    method: 'post',
    data: data
  });
}
//获取指标项类型
export function getIItemType(data) {
  return request({
    url: '/system/business/getIItemType',
    method: 'post',
    data: data
  });
}
//删除指标项
export function deleteIndicator(params) {
  return request({
    url: '/system/business/deleteIndicator',
    method: 'post',
    params: params
  });
}
//获取指标值列表
export function getIItemValueList(params) {
  return request({
    url: '/system/business/getIItemValueList',
    method: 'post',
    params: params
  });
}
//添加修改指标值
export function addIndicatorValue(data) {
  return request({
    url: '/system/business/addIndicatorValue',
    method: 'post',
    data: data
  });
}
//删除指标值
export function deleteIndicatorValue(params) {
  return request({
    url: '/system/business/deleteIndicatorValue',
    method: 'post',
    params: params
  });
}
//保存量表
export function saveScale(data) {
  return request({
    url: '/api/scale/addScale',
    method: 'post',
    data: data
  });
}
//校验量表
export function checkAssess(data) {
  return request({
    url: '/api/scale/checkAssess',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//获取结论页
export function getAssessConclusion(data) {
  return request({
    url: '/system/business/getAssessConclusion',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//
export function getAssesss(data) {
  return request({
    url: '/system/business/getAssesss',
    method: 'post',
    data: data
  });
}
//导出pdf
export function exportPdf(data) {
  return request({
    url: '/system/patient/exportPdf',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//获取医疗录入顶部
export function medica() {
  return request({
    url: '/system/operate/medica',
    method: 'post'
  });
}
//获取医疗录入侧边栏
export function mzOrBf() {
  return request({
    url: '/system/operate/mzOrBf',
    method: 'post'
  });
}
//获取ocr内容
export function ocrMuBan(data) {
  return request({
    url: '/system/operate/ocrMuBan',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//删除患者
export function deletePatient(params) {
  return request({
    url: '/system/patient/deleteScale',
    method: 'post',
    params: params
  });
}
//医疗录入提交
export function updateAssayReport(data) {
  return request({
    url: '/system/operate/updateAssayReport',
    method: 'post',
    data: data
  });
}
//获取最近录入时间
export function getRecentlyTime(params) {
  return request({
    url: '/system/operate/getRecentlyTime',
    method: 'post',
    params: params
  });
}
//获取化验检测列表
export function getAssay(data) {
  return request({
    url: '/system/operate/getAssay',
    method: 'post',
    data: data
  });
}
//获取化验检测详情
export function getAssayDetail(params) {
  return request({
    url: '/system/operate/getAssayDetail',
    method: 'post',
    params: params
  });
}
//删除化验检测记录
export function deleteAssay(params) {
  return request({
    url: '/system/operate/deleteAssay',
    method: 'post',
    params: params
  });
}
//删除一般情况记录
export function deleteGeneral(params) {
  return request({
    url: '/system/operate/deleteGeneral',
    method: 'post',
    params: params
  });
}

//获取用户一般情况表
export function getGeneralReport(params) {
  return request({
    url: '/system/operate/getGeneralReport',
    method: 'post',
    params: params
  });
}
//添加用户一般情况表
export function updateGeneralReport(data) {
  return request({
    url: '/system/operate/updateGeneralReport',
    method: 'post',
    data: data
  });
}
//医疗记录获取一般情况列表
export function getGeneral(data) {
  return request({
    url: '/system/operate/getGeneral',
    method: 'post',
    data: data
  });
}
//医疗记录获取一般情况列表详情
export function getGeneralDetail(params) {
  return request({
    url: '/system/operate/getGeneralDetail',
    method: 'post',
    params: params
  });
}

//获取电话随访量表列表
export function getTellSfList(data) {
  return request({
    url: '/system/suifang/getGeneral',
    method: 'post',
    data: data
  });
}
//电话随访小题目保存
export function addSuiRecord(data) {
  return request({
    url: '/system/suifang/addSuiRecord',
    method: 'post',
    data: data
  });
}
//电话随访大提交
export function commitSuiRecord(params) {
  return request({
    url: '/system/suifang/commitSuiRecords',
    method: 'post',
    params: params
  });
}
//点击电话随访回写
export function getPhoneSFList(params) {
  return request({
    url: '/system/suifang/getPhoneSFList',
    method: 'post',
    params: params
  });
}
//获取随访记录管理
export function getSFList(data) {
  return request({
    url: '/system/suifang/getSFList',
    method: 'post',
    data: data
  });
}
//删除随访记录
export function deleteSuiRecords(params) {
  return request({
    url: '/system/suifang/deleteSuiRecords',
    method: 'post',
    params: params
  });
}
//获取辅助检查列表
export function getAuxiliary(data) {
  return request({
    url: '/system/operate/getAuxiliary',
    method: 'post',
    data: data
  });
}
//添加用户辅助检查表
export function updateAuxiliaryReport(data) {
  return request({
    url: '/system/operate/updateAuxiliaryReport',
    method: 'post',
    data: data
  });
}
//获取辅助检查详情
export function getAuxiliaryDetail(params) {
  return request({
    url: '/system/operate/getAuxiliaryDetail',
    method: 'post',
    params: params
  });
}
//删除辅助检查记录
export function deleteAuxiliary(params) {
  return request({
    url: '/system/operate/deleteAuxiliary',
    method: 'post',
    params: params
  });
}
//量表规则
export function isAddAssess(data) {
  return request({
    url: '/api/scale/rule/isAddAssess',
    method: 'post',
    data: data
  });
}
//删除评估记录
export function deleteAssess(data) {
  return request({
    url: '/system/business/deleteAssess',
    method: 'post',
    data: data,
    headers: {
      isQs: true
    }
  });
}
//添加自评量表
export function addSfSelfAssessScale(data) {
  return request({
    url: '/system/selfScale/addSfSelfAssessScale',
    method: 'post',
    data: data
  });
}
//获取自评量表列表
export function getAllSfSelfAssessScale(params) {
  return request({
    url: '/system/selfScale/getAllSfSelfAssessScale',
    method: 'post',
    params: params
  });
}
//删除自评量表
export function deleteSfSelfAssessScale(params) {
  return request({
    url: '/system/selfScale/deleteSfSelfAssessScale',
    method: 'post',
    params: params
  });
}
//获取自评量表记录列表
export function getSfSelfAssessRecord(data) {
  return request({
    url: '/system/selfScaleValue/getSfSelfAssessRecord',
    method: 'post',
    data: data
  });
}
//获取自评量表记录详情
export function getRecordDetail(params) {
  return request({
    url: '/system/selfScaleValue/getRecordDetail',
    method: 'post',
    params: params
  });
}

// 推送自评量表
export function addSfSelfAssessScaleValue(data) {
  return request({
    url: '/system/selfScaleValue/addSfSelfAssessScaleValue',
    method: 'post',
    data: data
  });
}
//删除自评量表记录详情
export function deleteRecordDetail(params) {
  return request({
    url: '/system/selfScaleValue/deleteRecordDetail',
    method: 'post',
    params: params
  });
}
//电话随访手动推送
export function pushUserFollowUp(params) {
  return request({
    url: '/system/suifang/pushUserFollowUp',
    method: 'post',
    params: params
  });
}
//回去用药时间表
export function getMedList(params) {
  return request({
    url: '/system/patient/getMedList',
    method: 'post',
    params: params
  });
}
//添加用药
export function addMedicate(data) {
  return request({
    url: '/system/patient/addMedicate',
    method: 'post',
    data: data
  });
}
//修改患者用药列表
export function updateMedicate(data) {
  return request({
    url: '/system/patient/updateMedicate',
    method: 'post',
    data: data
  });
}
//删除患者用药列表
export function deleteMedicate(params) {
  return request({
    url: '/system/patient/deleteMedicate',
    method: 'post',
    params: params
  });
}
//获取复诊列表
export function returnVisitList(params) {
  return request({
    url: '/system/patient/returnVisitList',
    method: 'post',
    params: params
  });
}
//获取复诊列表
export function updateReViSta(params) {
  return request({
    url: '/system/patient/updateReViSta',
    method: 'post',
    params: params
  });
}
//获取复诊列表
export function addDiet(data) {
  return request({
    url: '/system/patient/addDiet',
    method: 'post',
    data: data
  });
}
//获取膳食列表
export function getDietList(params) {
  return request({
    url: '/system/patient/getDietList',
    method: 'get',
    params: params
  });
}
//删除膳食
export function deleteDiet(params) {
  return request({
    url: '/system/patient/deleteDiet',
    method: 'post',
    params: params
  });
}
//获取统计报表
export function reportScale(data) {
  return request({
    url: 'system/report/reportScale',
    method: 'post',
    data: data
  });
}

/** 获取筛选指标列表 */
export function getIndexList(data) {
  return post("/system/business/getIItems", data);
}

/** 获取筛选量表列表 */
export function getScaleList(data) {
  return post("/system/business/getScaleList", data);
}

/** 后台评估量表查看 */
export function getScaleCheckForPC(_ref) {
  var id = _ref.id;
  return post("/api/scale/getHosScaleInit", {
    id: Number(id)
  });
}
/** 知识点分类 */
export var getKnowledgeBaseClass = function getKnowledgeBaseClass(d) {
  return post("/system/disKno/getKnowledgeSort", d);
};
export var delKnowledgeBaseClass = function delKnowledgeBaseClass(id) {
  return get("/system/disKno/deleteKnowledgeSort", {
    id: id
  });
};
export var addKnowledgeBaseClass = function addKnowledgeBaseClass(d) {
  return post("/system/disKno/addKnowledgeSort", d);
};

/** 知识点 */
export var getKnowledgeBases = function getKnowledgeBases(d) {
  return post("/system/disKno/getKnowledge", d);
};
export var delKnowledgeBase = function delKnowledgeBase(id) {
  return get("/system/disKno/deleteKnowledge", {
    id: id
  });
};
export var addKnowledgeBase = function addKnowledgeBase(d) {
  return post("/system/disKno/addKnowledge", d);
};
export var getKanbanData = function getKanbanData() {
  return post("/system/kanban/getData", {});
};
export var getPatientDetail = function getPatientDetail(patientCode) {
  return get("/system/kanban/getPatientInfo", {
    patientCode: patientCode
  });
};

/** 处置患者 */
export var handlePatient = function handlePatient(d) {
  return post("/system/suifang/choseType", d);
};